// to easily copy and paste components
import React from 'react';
import {useTranslation} from 'react-i18next';

export default function ExpensesRecordSubmit({disabled, onSubmit}) {
    const {t} = useTranslation();

    return (
        <div className="form-button expenses-submit">
            <input
                type="submit"
                name="record_expense"
                value={t('expenses.record_expense')}
                disabled={disabled}
                onClick={onSubmit}
            />
        </div>
    );
}

